import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";

const ViewSalesType = () => {
  const token = config.token;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [salesTypes, setSalesTypes] = useState([]);

  //  ------For TableViewer ------
  const salesTypesRef = useRef([]);
  salesTypesRef.current = salesTypes;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //--------------------------------------------------------- get sales-type ---------------------------------------------------------r
  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}sales-type`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setSalesTypes(data.data);

          //  ------For TableViewer ------
          const salesTypesData = data.data.map((salesType) => ({
            sales_employee_type: salesType.sales_emp_type,
            parent_employee_type: salesType.parent_type_person,
            incentive: salesType.incentive,
            idNumber: salesType.tid,
          }));
          setRowData(salesTypesData);
          //  ------For TableViewer ------

          setLoading(false);
        }
      });
  }, [token]);

  // ------------------------------------------------------------------ Delete sales type -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete sales type. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}sales-type/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "sales employee type deleted successfully"
            );

            //  ------For TableViewer ------
            const updatedsalestype = [...salesTypesRef.current];
            updatedsalestype.splice(i, 1);
            setSalesTypes(updatedsalestype);

            const salesTypesData = updatedsalestype.map((salesType) => ({
              sales_employee_type: salesType.sales_emp_type,
              parent_employee_type: salesType.parent_type_person,
              incentive: salesType.incentive,
              idNumber: salesType.tid,
            }));
            setRowData(salesTypesData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "sales type not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting sales type");
        });
    };
  };

  // ------------------------------------------------------------------ edit sales type -----------------------------------------------------U
  const handleEditBtn = (id) => {
    navigate(`/addsalestype/${btoa(encodeURIComponent(id))}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "sales_employee_type", filter: true },
    { field: "parent_employee_type", filter: true },
    { field: "incentive", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Sales Type" subpath={["View Sales Types"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Sales Types</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addsalestype");
                }}
              >
                Add Sales Type
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewSalesType;
